import React from 'react';
import Select from 'react-select';
import { fetchClaimedOpsUsers } from '../../../services/api/offline-consult';

export default class ClaimedByFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            users: [],
        };
    }

    componentDidMount() {
        fetchClaimedOpsUsers()
            .then((response) => {
                response.unshift({
                    "opsUserId": -1,
                    "opsUserName": "Unclaimed"
                });

                this.setState({
                    users: response,
                });
            })
            .catch((err) => {
                console.error({ err },
                    'Couldnt fetch OPS Users');
                throw err;
            });
    }

    onChange = (selectedOption) => {
        this.props.onChange(selectedOption ? selectedOption.value : '');
    };

    render() {
        const { users } = this.state;
        console.log({ users }, 'State');

        const options = [
            { value: '', label: 'All' },
            ...users.map((u) => ({
                value: u.opsUserId,
                label: u.opsUserName
            }))
        ];

        const selectedOption = options.find(opt => opt.value == this.props.value) || options[0];

        return (
            <Select
                value={selectedOption}
                onChange={this.onChange}
                options={options}
                styles={{
                    control: (provided) => ({
                        ...provided,
                        minHeight: '40px',
                        fontSize: '12px'
                    }),
                    menu: (provided) => ({
                        ...provided,
                        maxHeight: '300px',
                        overflowY: 'auto',
                        zIndex: 9999
                    }),
                    menuList: (provided) => ({
                        ...provided,
                        maxHeight: '300px',
                        overflowY: 'auto'
                    }),
                    option: (provided) => ({
                        ...provided,
                        fontSize: '12px'
                    })
                }}
                menuPlacement="auto"
                menuPosition="fixed"
            />
        );
    }
}

